import { Alert, Modal } from 'react-bootstrap'
import CarnivoreModalProps from '../../_types/modal-props.type'
import { useDispatch, useSelector } from 'react-redux'
import { CarnivoreState } from '../../_types/carnivore-state.type'
import { FormEvent, useEffect, useState } from 'react'
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography
} from '@mui/material'
import { StyleHelper } from '../../helpers/styler-helper'
import RichTextEditor from '../rich-text-editor'
import { AlertService } from '../../services/alert.service'
import Actions from '../../redux/actions'

export default function SendMobileModal(props: CarnivoreModalProps) {
  const error = useSelector((state: CarnivoreState) => state.errMsg)
  const [loading, setLoading] = useState(false)
  const [emailContent, setEmailContent] = useState('')
  const [subject, setSubject] = useState('')
  const [includeSMS, setIncludeSMS] = useState(false)
  const [smsContent, setSmsContent] = useState('')

  const [alertType, setAlertType] = useState('alert')

  const dispatch = useDispatch()
  const alertService = new AlertService(dispatch)


  useEffect(() => {
    if (props.show) {
      setSubject('')
      setAlertType('alert')
    }
  }, [props.show])
  const _onSubmit = async (e: FormEvent) => {
    e.preventDefault()


    const newAlert = {
      content: emailContent,
      lists: ["ViPscw"],
      alertType,
      subject,
      source: "klaviyo"
    }

    const res = await alertService.createManualAlert(newAlert)
    console.log(res)
    if (res?.alert) {
      dispatch(Actions.setToast("Alert Sent", "Available on mobile, TradeDesk and Alert Feed"))
    }
    props.onClose()
  }



  return (
    <Modal show={props.show} onHide={props.onClose} centered size='xl'>
      <Modal.Header closeButton>
        <Modal.Title>Send New Alert</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Typography variant='body2'>This alert will go to mobile, trade desk and the alerts page</Typography>
        <StyleHelper.DoubleVerticalSpace />
        {error && <Alert variant='danger my-3'>{error}</Alert>}

        <form onSubmit={_onSubmit}>
          <Grid container>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel id='event-type-label'>Alert Type</InputLabel>
                <Select
                  labelId='event-type-label'
                  id='event-type-select'
                  value={alertType}
                  label='Alert Type'
                  required
                  onChange={e => setAlertType(e.target.value)}
                >
                  <MenuItem value=''>Select Type</MenuItem>
                  <MenuItem value='alert'>Alert</MenuItem>
                  <MenuItem value='update'>Update</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <StyleHelper.VerticalSpace />

          <TextField
            label='Subject'
            placeholder='used in subject'
            required
            variant='outlined'
            fullWidth
            value={subject}
            onChange={e => setSubject(e.target.value)}
          />
          <StyleHelper.VerticalSpace />
          <Typography variant='subtitle1' fontWeight={'bold'}>
            Message
          </Typography>
          <RichTextEditor
            initialValue={''}
            onHTMLChange={e => {
              setEmailContent(e)
            }}
          />
          <StyleHelper.VerticalSpace />

          <Divider />
          <StyleHelper.VerticalSpace />
          {/* <Box display={'flex'} alignItems={'center'}>
            <Box>
              <Typography variant='subtitle1' fontWeight={'bold'}>
                Include SMS Campaign?
              </Typography>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      checked={includeSMS}
                      onChange={e => setIncludeSMS(e.target.checked)}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  }
                  label={includeSMS ? 'YES' : 'NO'}
                />
              </FormGroup>
            </Box>

            <Button
              variant='contained'
              sx={{ marginLeft: 3 }}
              onClick={_copyFromEmail}
            >
              Copy from Email
            </Button>
          </Box>

          {includeSMS && (
            <>
              <StyleHelper.VerticalSpace />

              <TextField
                label='SMS Content'
                placeholder='content of sms message'
                required
                variant='outlined'
                multiline={true}
                rows={5}
                fullWidth
                value={smsContent}
                onChange={e => setSmsContent(e.target.value)}
              />
            </>
          )} */}
          <StyleHelper.VerticalSpace />

          <Button disabled={emailContent === ""} variant='contained' type='submit'>Send Alert</Button>
        </form>
      </Modal.Body>
    </Modal>
  )
}
